import Http from '../http'

export default {

  index(filter) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/agenda`, {params: {...filter}})
  },

}
